module.exports = __webpack_public_path__ + "img/03.b4b0cd2f.svg";